import React, { useEffect, useState } from 'react';
import { Grid, Box } from '@mui/material';
import { Modal } from 'react-responsive-modal';
import { MasterMessage } from '../../../masters/masterMessages';
import TextField from '@mui/material/TextField';
import Loading from '../../components/general/loading/loading';
import moment from 'moment/moment';
import {
    asyncGetCaseManagerId,
    asyncGetUserByRol,
    asyncPatchUserOneToOne,
} from '../../../services/caseManager.service';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FieldSelect from '../../components/general/fields/fieldSelect';
import AutoCompleteField from '../../components/general/fields/autoCompleteField';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import ButtonGeneral from '../../components/general/buttons/buttonGeneral';
import Save from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import FieldText from '../../components/general/fields/fieldText';
import { asyncPatchIdCaseManagement } from '../../../services/caseManagement.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

type Props = {
    open: boolean;
    onClose: (value: boolean) => void;
    onSave: (value: boolean) => void;
    idCase: string;
};

const ModalCaseManager = ({ open, onClose, onSave, idCase }: Props) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { id: idUserLog } = logUser || {};
    const [item, setItem] = useState<any>(undefined);
    const [type, setType] = useState<string>('');
    const [users, setUsers] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const {
        titleInfo,
        messageOneToOneOk,
        messageOneToOneError,
        messageManagementOk,
        messageManagemenError,
    } = MasterMessage.caseManager;

    const formik = useFormik({
        initialValues: {
            type: type || '',
            userEcaledId: '',
            observation: '',
        },
        validationSchema: Yup.object({
            type: Yup.string().required('La gestión es obligatoria'),
            userEcaledId: Yup.string().when(['type'], {
                is: (type: any) => Boolean(type === 'Escalar'),
                then: (schema) =>
                    schema.required('El agente a escalar es obligatorio'),
            }),
            observation: Yup.string().when(['type'], {
                is: (type: any) => Boolean(type === 'Solucionado'),
                then: (schema) =>
                    schema.required(
                        'La observación de la solución es obligatoria'
                    ),
            }),
        }),
        onSubmit: async (modalCaseManager: any) => {
            if (type === 'Solucionado') {
                asyncPatchIdCaseManagement(item.id, modalCaseManager)
                    .then((body: any) => {
                        if (body.items?.updated !== false) {
                            SwalCustomClass.fire({
                                text: messageManagementOk,
                                icon: 'success',
                                iconColor: '#1d1d1d',
                            });
                        } else {
                            SwalCustomClass.fire({
                                text: messageManagemenError,
                                icon: 'error',
                                iconColor: '#1d1d1d',
                            });
                        }
                    })
                    .finally(() => {
                        onClose(false);
                        onSave(true);
                    });
            } else {
                modalCaseManager.observation = 'Escalado';
                asyncPatchIdCaseManagement(item.id, modalCaseManager);
                asyncPatchUserOneToOne(item.id, modalCaseManager.userEcaledId)
                    .then((body: any) => {
                        if (body.items?.updated !== false) {
                            SwalCustomClass.fire({
                                text: messageOneToOneOk,
                                icon: 'success',
                                iconColor: '#1d1d1d',
                            });
                        } else {
                            SwalCustomClass.fire({
                                text: messageOneToOneError,
                                icon: 'error',
                                iconColor: '#1d1d1d',
                            });
                        }
                    })
                    .finally(() => {
                        onClose(false);
                        onSave(true);
                    });
            }
        },
    });

    useEffect(() => {
        asyncGetUserByRol('user').then((body: any) => {
            if (body.items !== undefined) {
                const data = body.items?.items.filter(
                    (u: any) => u.id !== idUserLog
                );
                setUsers(data);
            }
        });

        asyncGetCaseManagerId(idCase).then((body: any) => {
            if (body.items !== undefined) {
                setItem(body.items);
                setLoading(false);
                if (body.items.type !== null) {
                    setType(body.items.type);
                    formik.values.type = body.items.type;
                    formik.values.observation = body.items.observation;
                }
            }
        });
    }, [idCase]);

    const onCloseModal = () => {
        onClose(false);
    };

    const validateType = (value: string) => {
        if (value) {
            formik.values.type = value;
            setType(value);
        }
    };

    const options = [
        {
            id: 1,
            name: 'Solucionado',
        },
        {
            id: 2,
            name: 'Escalar',
        },
    ];

    return (
        <Modal
            open={open}
            onClose={onCloseModal}
            styles={{ modal: { minWidth: '90%' } }}
            classNames={{ root: 'modal-case-mr' }}
        >
            <Box>
                <h3>{titleInfo}</h3>
                <hr />
                {loading ? (
                    <Loading />
                ) : (
                    <Grid
                        container
                        spacing={{ xs: 1.5, md: 1.5 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Número de caso"
                                value={item.field1 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Canal de atención"
                                value={item.field2 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Canal Unificado"
                                value={item.field3 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Fecha de creación"
                                value={
                                    moment(item.field4).format('DD/MM/YYYY') ||
                                    ''
                                }
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Estado Real"
                                value={item.field5 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="No. Identificación"
                                value={item.field6 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Tipificación inicial"
                                value={item.field7 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Proceso inicial"
                                value={item.field8 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Subtipificación inicial"
                                value={item.field9 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Propietario"
                                value={item.field10 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="DIAS_SLA"
                                value={item.field11 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="SLAAJUSTADO"
                                value={item.field12 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Modificado Por"
                                value={item.field14 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Escalado BackOffice"
                                value={item.field15 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="LINEA"
                                value={item.field16 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="IES"
                                value={item.field17 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="RangoDias"
                                value={item.field18 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Resuelto/Activo"
                                value={item.field19 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <TextField
                                label="Fecha de Finalizacion Escalonamiento"
                                value={item.field20 || ''}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <FieldSelect
                                data={options}
                                label="Gestión"
                                name="type"
                                size="small"
                                defineValue="name"
                                required={true}
                                touched={formik.touched.type}
                                errors={formik.errors.type}
                                value={formik.values.type}
                                onChange={(e) => validateType(e.target.value)}
                            />
                        </Grid>
                        {type === 'Escalar' && (
                            <Grid item xs={12} md={6} lg={4}>
                                <AutoCompleteField
                                    data={users}
                                    label="Ingrese el nombre del agente a escalar"
                                    name="userEcaledId"
                                    size="small"
                                    touched={formik.touched.userEcaledId}
                                    errors={formik.errors.userEcaledId}
                                    value={formik.values.userEcaledId}
                                    onChangeValue={(value) =>
                                        formik.setFieldValue(
                                            'userEcaledId',
                                            value
                                        )
                                    }
                                    getOptionLabel={(option) =>
                                        option
                                            ? option.name + ' ' + option.surname
                                            : ''
                                    }
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                label="Descripción"
                                value={item.field13 || ''}
                                fullWidth
                                multiline
                                rows={8}
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        {type === 'Solucionado' && (
                            <Grid item xs={12} md={12} lg={12}>
                                <FieldText
                                    label="Observación Solución"
                                    name="observation"
                                    size="small"
                                    required={true}
                                    rows={4}
                                    touched={formik.touched.observation}
                                    errors={formik.errors.observation}
                                    value={formik.values.observation}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                        )}
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{ textAlign: 'right' }}
                        >
                            <ButtonGeneral
                                onClick={formik.handleSubmit}
                                startIcon={<Save color="secondary" />}
                                title="Guardar"
                                sx={{ mr: 1 }}
                            />
                            <ButtonGeneral
                                onClick={onCloseModal}
                                startIcon={<CancelIcon color="secondary" />}
                                title="Cancelar"
                            />
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Modal>
    );
};

export default ModalCaseManager;
